
import { XIcon, PlayIcon } from 'vue-feather-icons';

// const imgUrls = [
//   "https://cdn.digipart.fr/upload/images/retouched/4420-REGIA1009-MARINE-6.jpg",
//   "https://cdn.digipart.fr/upload/images/retouched/4325-CALOU102-ECRU-GROSPOIS-56402.jpg",
//   "https://cdn.digipart.fr/upload/images/retouched/4325-CALOU102-ECRU-GROSPOIS-56401.jpg",
// ];
export default {
  props: {
    imgUrls: {
      required: false,
    },
    hide: {
      type: Boolean,
    },
    startImgIndex: {
      type: Number,
    },
    videosUrl: {
      required: false,
      type: Array,
    },
  },
  data() {
    return {
      imgSrc: '',
      isImg: true,
      mainSwiper: null,
      thumbsSwiper: null,
      windowWidth: 0,
    };
  },
  computed: {
    mediaItems() {
      const items = [];
      const videos = this.videosUrl || [];
      const images = this.imgUrls || [];

      // Find cover video
      const coverVideo = videos.find((v) => v.Cover);
      const otherVideos = videos.filter((v) => !v.Cover);

      if (coverVideo) {
        items.push({ type: 'video', src: coverVideo.Src });
      }

      images.forEach((img) => {
        items.push({ type: 'image', src: img.Src });
      });

      otherVideos.forEach((video) => {
        items.push({ type: 'video', src: video.Src });
      });

      return items;
    },
    initialIndex() {
      // Determine what content corresponded to startImgIndex
      let targetSrc = null;
      let targetType = null;
      const productImagesCount = this.imgUrls ? this.imgUrls.length : 0;

      if (this.startImgIndex < productImagesCount) {
        // It was an image
        if (this.imgUrls && this.imgUrls[this.startImgIndex]) {
          targetSrc = this.imgUrls[this.startImgIndex].Src;
          targetType = 'image';
        }
      } else {
        // It was a video
        const videoIndex = this.startImgIndex - productImagesCount;
        if (this.videosUrl && this.videosUrl[videoIndex]) {
          targetSrc = this.videosUrl[videoIndex].Src;
          targetType = 'video';
        }
      }

      if (targetSrc) {
        const index = this.mediaItems.findIndex(
          (item) => item.src === targetSrc && item.type === targetType
        );
        return index !== -1 ? index : 0;
      }
      return 0;
    },
    thumbsPerView() {
      if (this.windowWidth > 0) {
        return this.windowWidth / 40;
      }
      return 'auto';
    },
  },
  components: {
    XIcon,
    PlayIcon,
  },
  methods: {
    setBgImagePos($e) {
      const bigImg = this.$refs.bigImg;
      const y = $e.clientY;
      const h = bigImg.clientHeight;
      bigImg.style.backgroundPositionY = (y / h) * 100 + '%';
    },
    changeUrlImg(imgUrl, type) {
      if (type === 'video') {
        this.isImg = false;
        this.imgSrc = imgUrl;
      } else {
        // const bigImg = this.$refs.bigImg;
        // bigImg.style.backgroundImage = `url(${imgUrl})`;
        this.imgSrc = imgUrl;
        this.isImg = true;
      }
    },
    close() {
      this.$emit('onClose');
    },
    setMainSwiper(swiper) {
      this.mainSwiper = swiper;
    },
    setThumbsSwiper(swiper) {
      this.thumbsSwiper = swiper;
    },
    onMainSlideChange(swiper) {
      const index = swiper.activeIndex;
      if (this.thumbsSwiper) {
        this.thumbsSwiper.slideTo(index);
      }
      const item = this.mediaItems[index];
      if (item) {
        this.changeUrlImg(item.src, item.type);
      }
    },
    onThumbnailClick(index, item) {
      this.changeUrlImg(item.src, item.type);
      if (this.mainSwiper) {
        this.mainSwiper.slideTo(index);
      }
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
  },
  mounted() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
    // Use initialIndex logic to set initial view state
    const item = this.mediaItems[this.initialIndex];
    if (item) {
      this.isImg = item.type === 'image';
      this.imgSrc = item.src;
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
};
